module.exports = __webpack_public_path__ + "img/required.gif";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/img/payment/required.gif
// module id = 377
// module chunks = 0